import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Loader from 'react-loader-spinner';
window.teamMembers = [];
class ManageCampaign extends Component {
    constructor() {
        super();

        this.dialogClose = () => {
            this.setState({
                hideupdateDialog: false, hideAddDialog: false, hideDeletePopup: false,
                hideScriptIgnore: false, hideDeleteAllPopup: false, hideIncorrectPassword: false
            });
        };

        this.DeletedialogClose = () => {
            this.setState({ hideTextAreaPopup: false });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };
        //for delete success
        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.dialogInstance.hide();
                this.fetchCampaign()
                this.setState({ disabled: false })
            }
        }];

        //for update dialog component ok click
        this.Okbutton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.fetchCampaign()
                this.dialogClose();
            }
        }];

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteCampaignDetails(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        this.state = {
            data: [],
            editedId: '-1',
            contentEditable: "false",
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
        }
    }
    notifyFailToCreate() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred. \n Please try again</b>, {
            position: "top-center",
            color: "red"

        });
    }
    viewCampaign = (props, e) => {

        var campaignLeadId = props.original;


        this.props.history.push({
            pathname: '/projectmgmt/out-reach-campaign/manage-campaign/view-campaign-leads',
            state: campaignLeadId

        })
    }

    deleteCampaignDetails = (id) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(id, 1);
        } else {
            $.ajax({
                url: "/salesdesk-api/delete-campaign-detail",
                async: false,
                method: 'POST',
                data: {
                    projectId: localStorage.getItem('currentProjectId'),
                    id: id
                },
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteConstructorVariables.notifyDelete();
                        deleteRowViewController.splice(id, 1);
                    } else {
                        deleteRowViewController.notifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/sales-desk/login";
                    }
                }
            });
        }

        if (this.state.deleteRow) {
            this.state.data.splice(id, 1);
        }
        // deleteConstructorVariables.fetchLeadDetails();
        deleteConstructorVariables.fetchCampaign(localStorage.getItem('currentProjectId'));

    }
    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Campaign detail deleted successfully</b>, {
            position: "top-center",
        });
    }

    componentDidMount() {
        var settingController = this;
        setTimeout(() => {
            settingController.fetchCampaign();
        }, 300);

        document.addEventListener("projectChanged", function (event) {
            settingController.projectId = event.projectId;
            settingController.fetchCampaign(event.projectId);
        });
    }


    fetchCampaign = (projectId) => {
        var fetchCampaign = this;
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        $.ajax({
            url: "/salesdesk-api/fetch-campaign",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },

            success: function (res) {
                if (res.success === true) {
                    fetchCampaign.state.data = res.result;
                    fetchCampaign.setState(fetchCampaign);
                } else {
                    fetchCampaign.notifyFailToCreate();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        });
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }
    render() {
        const { data } = this.state
        this.columns = [
            {
                Header: <b>Name</b>,
                textAlign: 'screenLeft',
                accessor: 'name',
                sortable: false,
                headerStyle: { marginLeft: '10px' },
                Cell: props => {
                    return (
                        <div name="userName">
                            <div className="textarea"
                                style={{
                                    background: 'white', height: '5%',
                                    resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                    border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                                }}
                                id={"userName" + props.index}
                                class="form-control"
                                rows="1"
                                suppressContentEditableWarning
                                contentEditable={!((props.original.id != "") ? props.original.id != this.state.editedId : false)}
                            >
                                {props.original.name}
                            </div>
                        </div>
                    )
                },
            },

            {
                Header: () => <b>Created By</b>,
                accessor: 'userEmail',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                Cell: props => (
                    <div name="userEmail">
                        <div className="textarea"
                            style={{
                                background: 'white', height: '5%',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"userEmail" + props.index}
                            class="form-control"
                            rows="1"
                            suppressContentEditableWarning
                            contentEditable={!((props.original.id != "") ? props.original.id != this.state.editedId : false)}
                        >
                            {props.original.createdBy}
                        </div>
                    </div>
                )
            },
            {
                Header: <b>Action</b>,
                accessor: 'action',
                filterable: false,
                flexGrow: 1,
                sortable: false,
                headerStyle: { textAlign: 'center' },
                Cell: props => (
                    <div>
                        <button className='btn navyblue-btn' style={{ marginLeft: '5vw', width: '10vw' }}
                            onClick={e => this.viewCampaign(props, e)}>View Campaigns</button>

                        <button style={{
                            backgroundColor: "#ffffff", border: "none", marginLeft: '6px'
                        }} title="Delete">
                            <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                style={{ marginBottom: '-0.75vw', backgroundColor: '#282a65', borderRadius: '5px', padding: '1.5px', height: '34px' }}
                                onClick={() => (props.original.id) === '' ?
                                    this.fetchCampaign() :
                                    this.setState({
                                        hideDeletePopup: true, deletePropIndex: props.index, propsId: props.original.id
                                    })} /></button>

                    </div>
                ),

            },
        ]


        return (
            <div>
                <div style={{ background: "#F9F9FB" }}>
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <div className="wrapper" style={{ marginTop: "-20px" }}>
                        <div className="row" style={{ marginLeft: "2px", marginTop: '-15px' }}>
                            <div className="col-sm-5" >
                                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '35px' }}>Manage Campaign</h6>
                            </div>

                        </div>

                        <div className="content">
                            <div className="container-fluid">
                                <div className="row" style={{ marginTop: '1%' }}>
                                    <div className="col-lg-12 ">
                                        <div className="card">
                                            <ReactTable
                                                data={data}
                                                columns={this.columns}
                                                defaultPageSize={5}
                                                pageSizeOptions={[5, 10, 15]}
                                                onPageChange={this.onPageChange}
                                                page={this.state.pageNum}
                                            />
                                        </div>
                                        <ToastContainer className="Toast-at-center" />
                                    </div>
                                </div>
                            </div>
                            {/*Dialog Component For Deletion Confirmation*/}
                            <DialogComponent width='400px' animationSettings={this.settings}
                                header='Delete Confirmation' showCloseIcon={true} buttons={this.buttons}
                                ref={dialog => this.dialogInstance = dialog}
                                visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                    content="" />&nbsp;Do you want to delete the campaign?
                                Note: Press 'Yes' to delete or press 'No' to decline.
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</DialogComponent>
                        </div>
                    </div>
                </div>
            </div>

        )
    }


}

export default ManageCampaign;


// WEBPACK FOOTER //
// ./src/sales-desk/projectmgmt/ManageCampaign.js